import { render, staticRenderFns } from "./QualityReturns.vue?vue&type=template&id=79a7e5b0&"
import script from "./QualityReturns.vue?vue&type=script&lang=js&"
export * from "./QualityReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports